export default "__VITE_ASSET__k$ZJV9aT__"